import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Notifications from "./Notifications";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import cookie from "js-cookie";
import axios from "axios";

const Layout = props => {
	const [settings, setSettings] = useState({});
	const meta = useSelector(state => state.meta);
	const [logoUrl, setLogoUrl] = useState(null);

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const response = await axios.get(
					`${process.env.REACT_APP_API_URL}/settings/siteInfo`,
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				);
				setLogoUrl(
					`${process.env.REACT_APP_MAIN_URL}/${response?.data?.data?.siteInfos?.[0]?.appLogo}`
				);
			} catch (error) {
				console.error("Error fetching settings:", error);
			}
		};

		fetchSettings();
	}, []);

	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_API_URL}/settings/siteInfo`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSettings(response.data.data.siteInfos?.[0]);
			});
	}, []);
	return (
		<div className="main-wrapper">
			<Sidebar logoUrl={logoUrl} />
			<div className="content-wrapper" id="content-wrapper">
				<Header breadcrumbTitle={meta.breadcrumb} logoUrl={logoUrl} />
				<Notifications />
				<div className="content">
					<div className="page-meta">
						<h1 className="main-title">{meta.title}</h1>
						{meta.button.show && (
							<Link to={meta.button.link} className="bt bt-success">
								{meta.button.text}
							</Link>
						)}
					</div>
					{props.children}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
